import localization from './localization';

export const localizationReducer = localization.reducer;
export const localizationAction = localization.actions;
